export default {
  title_text: {
    en: "Congratulations",
    de: "Herzlichen Glückwunsch!",
    ru: "Поздравляю!",
    tr: "Tebrikler!",
    el: "Συγχαρητήρια!",
    bg: "Поздравления!",
    ro: "Felicitări!",
    cs: "Gratulujeme!",
    sr: "Čestitamo!",
    hu: "Gratulálunk!"
  },
  subtitle_text: {
    en: "Thank you for your participation in the briefing. Now you can download your certificate.",
    de: "Vielen Dank für Ihre Teilnahme an der Einweisung. Sie können jetzt Ihr Zertifikat herunterladen.",
    ru: "Благодарим вас за участие в брифинге. Теперь вы можете загрузить свой сертификат.",
    tr: "Bilgilendirmeye katıldığınız için teşekkür ederiz. Artık sertifikanızı indirebilirsiniz.",
    el: "Σας ευχαριστούμε για τη συμμετοχή σας στην ενημέρωση. Τώρα μπορείτε να κατεβάσετε το πιστοποιητικό σας.",
    bg: "Благодарим Ви за участието в инструктажа. Сега можете да изтеглите своя сертификат.",
    ro: "Vă mulțumim pentru participarea la briefing. Acum puteți descărca certificatul dumneavoastră.",
    cs: "Děkujeme za účast na briefingu. Nyní si můžete stáhnout svůj certifikát.",
    sr: "Hvala vam na učešću u obuci. Sada možete preuzeti svoj sertifikat.",
    hu: "Köszönjük a részvételt a tájékoztatón. Most letöltheti a tanúsítványát."
  },
  click_hint: {
    en: "The certificate was also sent to the administration.",
    de: "Das Zertifikat wurde auch an die Administration geschickt.",
    ru: "Сертификат также был отправлен в администрацию.",
    tr: "Sertifika ayrıca yönetime de gönderildi.",
    el: "Το πιστοποιητικό στάλθηκε επίσης στη διοίκηση.",
    bg: "Сертификатът също беше изпратен на администрацията.",
    ro: "Certificatul a fost trimis și administrației.",
    cs: "Certifikát byl také odeslán správě.",
    sr: "Sertifikat je takođe poslat administraciji.",
    hu: "A tanúsítványt az adminisztrációnak is elküldtük."
  },
  download_button: {
    en: "Download",
    de: "Herunterladen",
    ru: "Скачать",
    tr: "İndir",
    el: "Κατεβάστε",
    bg: "Изтегли",
    ro: "Descarcă",
    cs: "Stáhnout",
    sr: "Preuzmi",
    hu: "Letöltés"
  },
  logout_button: {
    en: "Logout",
    de: "Abmeldung",
    ru: "Выйти",
    tr: "Çıkış",
    el: "Αποσύνδεση",
    bg: "Изход",
    ro: "Deconectare",
    cs: "Odhlásit se",
    sr: "Odjava",
    hu: "Kijelentkezés"
  }
};
